import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  Input,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { MenuItem } from 'primeng';

@Component({
  templateUrl: './card-menu.component.html',
  selector: 'card-menu',
  styleUrls: ['./card-menu.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CardMenuComponent implements OnInit {
  @Output() itemsChange: EventEmitter<MenuItem[]>;
  public _items: MenuItem[] = [];
  @Input('items')
  public set items(value: MenuItem[]) {
    this._items = value;
    this.itemsChange.emit(value);
  }
  public get items(): MenuItem[] {
    return this._items;
  }

  public _menu: MenuItem[] = [];
  @Input('menu')
  public set menu(value: MenuItem[]) {
    if (!value || this.items.length > 0) return;

    var menu = [];
    for (var i = 0; i < value.length; i++) {
      this.items.push(this.CreateMenuItem(value[i]));
    }
  }

  constructor() {
    this.itemsChange = new EventEmitter<MenuItem[]>();
  }

  ngOnInit() {
    this.items = [];
  }

  CreateMenuItem(item): MenuItem {
    var result: any = {};
    result.label = item.label;
    result.icon = item.icon;
    result.command = item.command;

    if (item.items && item.items.length > 0) {
      result.items = [];
      for (var i = 0; i < item.items.length; i++) {
        result.items.push(this.CreateMenuItem(item.items[i]));
      }
    }
    return result;
  }
}
